export default "__VITE_ASSET__CtsYVSyp__"